import React from 'react';
import ContentLoader from 'react-content-loader';
import { Box } from '@mafc/trolly';
import COLORS from 'theme/colors';
import { useTranslation } from 'react-i18next';

const displayModes = ['block'];

interface IRectProps {
  x: string;
  y: string;
  rx: string;
  ry: string;
  width: string;
  height: string;
}
const BasicLoader = ({
  height,
  width,
  rectData,
}: {
  height: number;
  width: number;
  rectData: IRectProps[];
}) => {
  return (
    <ContentLoader
      className="skeleton-loader"
      height={height}
      width={width}
      speed={2}
      primaryColor={COLORS.LIGHT_GREY}
      secondaryColor={COLORS.SHIMMER_COLOR}
    >
      {rectData.map((data: any, index: number) => {
        return (
          <rect
            key={index}
            x={data.x}
            y={data.y}
            rx={data.rx}
            ry={data.ry}
            width={data.width}
            height={data.height}
          />
        );
      })}
    </ContentLoader>
  );
};
const CheckoutShimmer = () => {
  const { t } = useTranslation();
  return (
    <Box display={displayModes} sx={{ position: 'relative' }}>
      <BasicLoader
        height={210}
        width={800}
        rectData={[
          { x: '26', y: '16', rx: '5', ry: '5', width: '918', height: '80' },
          { x: '26', y: '106', rx: '5', ry: '5', width: '918', height: '40' },
          { x: '26', y: '160', rx: '5', ry: '5', width: '418', height: '30' },
        ]}
      />
      <Box display={displayModes} backgroundColor={COLORS.WHITE} ml={[1, 4]}>
        <BasicLoader
          height={210}
          width={800}
          rectData={[
            { x: '16', y: '16', rx: '5', ry: '5', width: '148', height: '30' },
            { x: '670', y: '106', rx: '5', ry: '5', width: '120', height: '30' },
            { x: '16', y: '56', rx: '5', ry: '5', width: '772', height: '40' },
            { x: '450', y: '106', rx: '5', ry: '5', width: '338', height: '30' },
            { x: '16', y: '146', rx: '5', ry: '5', width: '50', height: '50' },
            { x: '76', y: '146', rx: '5', ry: '5', width: '50', height: '50' },
            { x: '136', y: '146', rx: '5', ry: '5', width: '50', height: '50' },
          ]}
        />
      </Box>
      <Box
        as="span"
        sx={{
          position: 'absolute',
          bottom: '200px',
          width: '100%',
          textAlign: 'center',
          top: '35%',
          fontSize: [2, 3],
          whitespace: 'nowrap',
        }}
      >
        {t('shimmerText')}
      </Box>
      <BasicLoader
        height={180}
        width={800}
        rectData={[
          { x: '26', y: '16', rx: '5', ry: '5', width: '200', height: '20' },
          { x: '646', y: '16', rx: '5', ry: '5', width: '200', height: '20' },
          { x: '26', y: '46', rx: '5', ry: '5', width: '918', height: '80' },
        ]}
      />
    </Box>
  );
};

export const PromotionLoader = () => {
  return (
    <BasicLoader
      height={180}
      width={800}
      rectData={[
        { x: '0', y: '26', rx: '5', ry: '5', width: '418', height: '30' },
        { x: '0', y: '76', rx: '5', ry: '5', width: '918', height: '100' },
      ]}
    />
  );
};

export default CheckoutShimmer;
